import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "24",
  viewBox: "0 0 21 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.71519 0.542866C2.38265 -0.277158 0.666992 0.681541 0.666992 2.24618V21.7546C0.666992 23.3192 2.38265 24.2779 3.71519 23.4579L19.5658 13.7037C20.8348 12.9227 20.8348 11.078 19.5658 10.2971L3.71519 0.542866Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }